import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { assignModelOptions, ConfirmationMeasuringPointsModel, MeasuringPointModel } from '@evorait/pace-core';

@Component({
    selector: 'pace-confirmation-measuring-points',
    templateUrl: './confirmation-measuring-points.component.html',
    styleUrls: ['./confirmation-measuring-points.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ConfirmationMeasuringPointsComponent implements OnInit {
    @Input()
    public model: ConfirmationMeasuringPointsModel;

    @Input()
    public parentForm: FormArray;

    // form
    public measuringPointsForm: FormGroup;
    public measuringPointsChildren: FormArray;
    public constructor(
        private readonly changeDetector: ChangeDetectorRef,
        private readonly formBuilder: FormBuilder,
    ) {}

    public ngOnInit(): void {
        this.measuringPointsChildren = this.formBuilder.array([]);
        this.measuringPointsForm = this.formBuilder.group({
            children: this.measuringPointsChildren,
        });

        this.parentForm.push(this.measuringPointsForm);
    }

    public newValueSetRequired(point: MeasuringPointModel): void {
        if (point.isNotAvailable.model.value) {
            point.newValue.value = undefined;
        }
        point.newValue = assignModelOptions(
            point.newValue,
            {
                ...point.newValue.options,
                readonly: point.isNotAvailable.model.value,
                required: !point.isNotAvailable.model.value,
            },
            point,
        );
        // need to detectChanges, otherwise the component will not update.
        this.changeDetector.detectChanges();
    }
}
